import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Page, Crud, Upload } from '../../components';
import { message, Input, Select } from 'antd';
import { config } from '../../utils/config';
const Option = Select.Option
const { CrudTable, CrudForm, CrudFilter, CrudButtons } = Crud;
const { SelectFile } = Upload;

/**
 * 模板文件
 */
export class FruiTempFilePage extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount() {

    this.fetchList(1);

  }

  fetchList = (page, value) => {
    const { getTempFileListAction } = this.props.actions;
    let params = Object.assign({}, value, { page: page })
    getTempFileListAction(params)
  }


  getDataSource = () => {
    const { user } = this.props;
    const { tempFilesById, tempFilesList } = user;
    if (!tempFilesList) return [];
    return tempFilesList.map(id => tempFilesById[id]);
  }

  catTempFile = (record) => {
    console.log(record)
    if (record) {
      window.open(`${config.attachUrl}${record}`);
    } else {
      message.error('附件不存在');
    }
  }

  get listProps() {
    const { user, actions } = this.props;
    const { delTempFileAction } = actions;
    const { getTempFileListActionPending, getTempFileListTotal, getTempFileListPage } = user;



    return {
      dataSource: this.getDataSource(),
      loading: getTempFileListActionPending,
      columns: [
        {
          title: "附件名称",
          dataIndex: 'name',
          key: 'name',
          width: 180,
        },
        {
          title: '附件类型',
          dataIndex: 'type',
          key: 'type',
          width: 180,
          render: type => {
            if (type == 1) {
              return "标签模板"
            } else if (type == 2) {
              return "合格证模板"
            }
          }
        }
      ],
      op: [
        {
          key: 1,
          name: "查看附件",
        },
        {
          key: 3,
          name: '删除',
          buttonProps: {
            icon: 'delete',
            type: 'danger',
          },
          needConfirm: true,
          confirmTitle: '确认删除',
        },
      ],
      handleMenuClick: (record, item) => {
        if (item.key === 1) {
          this.catTempFile(record.path)
        }
        if (item.key === 3) {
          delTempFileAction(record.id).then(res => {
            this.fetchList(getTempFileListPage)
          })
        }
      },
    };
  }

  getArrayType = () => {
    return [{
      id: 1,
      name: '标签'
    }, {
      id: 2,
      name: '合格证'
    }].map(item => (
      <Option key={item.id}>{item.name}</Option>
    ))
  }

  get filterProps() {
    const { actions, user } = this.props;
    const { pro_lnglistModalChange, showAddModal } = actions;

    return {
      title: '',
      searchElements: [
        {
          key: 'name',
          widget: Input,
          widgetProps: {
            placeholder: '附件名称',
          },
        }, {
          key: 'type',
          widget: Select,
          children: this.getArrayType(),
          widgetProps: {
            width: '200px',
            style: { width: 200 }
          }
        }

      ],
      onFilterChange: value => {
        console.log('onFilterChange', value);
        this.fetchList(1,value);
      }
    };
  }


  get buttonProps() {
    const { showAddModal } = this.props.actions;
    return {
      buttons: [
        {
          name: '添加附件',
          buttonProps: {
            type: 'primary',
          },
          onClick: () => {
            showAddModal(true)
          },
        }
      ],
    };
  }


  get modalProps() {
    const { actions, user } = this.props;
    const { showAddModal, addTempFileAction } = actions;
    const {
 visbileAddModal, addTempFileActionPending
    } = user;

    return {
      visible: visbileAddModal,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: addTempFileActionPending,
      title: '上传附件',
      centered: true,
      elements: [
        {
          key: 'name',
          label: '附件名称',
          widget: Input
        },
        {
          key: 'type',
          label: '附件类型',
          widget: Select,
          children: this.getArrayType()
        },
        {
          key: 'file',
          label: '上传文件',
          initialValue: [],
          widget: SelectFile,
          widgetProps: {},
        },
      ],
      onOk: data => {
        console.log('data', data);
        let params = new FormData();
        params.append('file', data.file);
        params.append('name', data.name);
        params.append('type', data.type)
        addTempFileAction(params).then(res => {
          showAddModal(false);
          this.fetchList();
        });
      },
      onCancel() {
        showAddModal(false);
      },
    };
  }


  render() {
    return (
      <Page inner>
        <CrudFilter {...this.filterProps} />
        <CrudButtons {...this.buttonProps} />
        <CrudTable {...this.listProps} />
        <CrudForm {...this.modalProps} />
      </Page>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FruiTempFilePage);



// WEBPACK FOOTER //
// ./src/features/user/FruiTempFilePage.js